export enum EPetGenderType {
  MALE = 'M',
  FEMALE = 'F',
}
